<template>
    <route-tabs :tabs="tabs" tab-prefix="logs_"></route-tabs>
</template>

<script lang="ts" type="typescript">
import Vue from "vue"
import { Component } from "vue-property-decorator";
import RouteTabs from "@/components/route-tabs.vue"

@Component({
    components: {
        RouteTabs
    }
})
export default class LogsView extends Vue {
    tabs = [
        {key: 'file', name: 'Files'},
        {key: 'db', name: 'Database'},
    ]
}
</script>